import { useContext } from "react";
import { useNavigate, } from 'react-router-dom';

//import axios from 'axios';
import axios_api from '../../Api';
import { API_URL, AUTH_TOKEN } from '../../Context';
import ConfirmationModal from '../common/ConfirmationModal';


export default function FormHeaderSpecialist ({ taskId, taskParams, statusDisplay }){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();


  function ReturnTaskClick(taskId) {
    let params = {'operation': 'return-task-to-lab'};
    
    axios_api.put(api_url + `/manage_task/` + taskId, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        //navigate("/");
        navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function DeleteTaskClick(taskId) {

    axios_api.delete(api_url + `/manage_task/` + taskId, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        navigate("/");
        navigate(0);
      },
      (error) => {
        console.log(error);
        alert(error.response?.data)
      }
    );
  }
  
  function RemoveDataFromEAS(taskId) {

    axios_api.delete(api_url + `/export_task_data/` + taskId, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Task data deleted from EAS");
        navigate('/task/' + taskId);
        navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  return (
    <>
      <ConfirmationModal
        modalId="confirmTaskDeleteModal"
        headerText="Задание"
        messageText={[
          "Вы уверены, что хотите удалить задание?"
        ]}
        confirmButtonText="Удалить" 
        Action={() => DeleteTaskClick(taskId)}
        danger
      />

      <ConfirmationModal
        modalId="confirmTaskReturnModal"
        headerText="Договор"
        messageText={[
          "Вы уверены, что хотите вернуть задание лаборатории для исправления данных?"
        ]}
        confirmButtonText="Вернуть задание" 
        Action={() => ReturnTaskClick(taskId)}
      />

      <ConfirmationModal
        modalId="confirmTaskDataRemoveFromEAS"
        headerText="Задание"
        messageText={[
          "Вы уверены, что хотите удалить данные из промежуточной БД ИАС?"
        ]}
        confirmButtonText="Удалить данные" 
        Action={() => RemoveDataFromEAS(taskId)}
        danger
      />

      <div className="row m-3">
        <div className='col-9'>
          <div className="form-head p-3 d-grid gap-3 d-md-flex justify-content-between">
            <div>
              <h6>Цикл: <b>{taskParams.form.cycle}</b></h6>
              <h6>Представление результатов до: <b>{taskParams.deadline_date}</b></h6>
              <h6>Результаты представлены: <b>{taskParams.completed_date}</b></h6>
              <h6>Номера ОПК: {taskParams.samples}</h6>
              <h6>Cтатус: <b>{statusDisplay}</b> </h6>
            </div>
            <div className="dropdown mt-3 me-3">
              <button className="btn lk-button dropdown-toggle px-4" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Действия 
              </button>
              <ul className="dropdown-menu">
                { taskParams.status === 'SENT' &&
                  <>
                    <button className='dropdown-item lk-menu-dropdown' data-bs-toggle="modal" data-bs-target="#confirmTaskReturnModal">Вернуть задание лаборатории</button>  
                    <button className='dropdown-item lk-menu-dropdown' onClick={() => navigate('/export/' + String(taskParams.id))}>Выгрузить данные в ИАС...</button>
                  </>
                }
                { taskParams.status === 'EXPORTED_TO_EAS' &&
                  <>
                    <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" disabled>Вернуть задание лаборатории</button>
                    <button className='dropdown-item lk-menu-dropdown' disabled> Выгрузить данные в ИАС...</button>
                    <button className='dropdown-item lk-menu-dropdown' data-bs-toggle="modal" data-bs-target="#confirmTaskDataRemoveFromEAS">Удалить данные из ИАС...</button>
                  </>
                }
                { !(['SENT', 'EXPORTED_TO_EAS'].includes(taskParams.status)) &&                   
                  <>
                    <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" disabled>Вернуть задание лаборатории</button>
                    <button className='dropdown-item lk-menu-dropdown' disabled> Выгрузить данные в ИАС...</button>
                  </>
                }
                <div className="dropdown-divider"></div>
                <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" data-bs-target="#confirmTaskDeleteModal">Удалить задание</button>
              </ul>
            </div>
          </div>
        </div>
      </div>    
    </>
  )
}